module.exports = __webpack_public_path__ + "img/raildust_overlay.84bbf839.jpeg";